"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_ENTITY_DIRECTORY_PATH = exports.IMPORT_ENTITY_TYPE = exports.IMPORT_ENTITY_STATUS = void 0;
var IMPORT_ENTITY_STATUS;
(function (IMPORT_ENTITY_STATUS) {
    IMPORT_ENTITY_STATUS["RUNNING"] = "RUNNING";
    IMPORT_ENTITY_STATUS["FAILED"] = "FAILED";
    IMPORT_ENTITY_STATUS["COMPLETED"] = "COMPLETED";
})(IMPORT_ENTITY_STATUS = exports.IMPORT_ENTITY_STATUS || (exports.IMPORT_ENTITY_STATUS = {}));
var IMPORT_ENTITY_TYPE;
(function (IMPORT_ENTITY_TYPE) {
    IMPORT_ENTITY_TYPE["PRODUCT"] = "PRODUCT";
})(IMPORT_ENTITY_TYPE = exports.IMPORT_ENTITY_TYPE || (exports.IMPORT_ENTITY_TYPE = {}));
var IMPORT_ENTITY_DIRECTORY_PATH;
(function (IMPORT_ENTITY_DIRECTORY_PATH) {
    IMPORT_ENTITY_DIRECTORY_PATH["PRODUCT"] = "import/product";
    IMPORT_ENTITY_DIRECTORY_PATH["TEMPLATE"] = "import/template";
})(IMPORT_ENTITY_DIRECTORY_PATH = exports.IMPORT_ENTITY_DIRECTORY_PATH || (exports.IMPORT_ENTITY_DIRECTORY_PATH = {}));
//# sourceMappingURL=importEntity.js.map